module.exports = __webpack_public_path__ + "img/shop_C_4.c600703a.png";